import { useCallback, useMemo } from "react";
import { useSearch, useNavigate } from "@tanstack/react-router";
import type { AdminSearchParams } from "@/features/admin/types";
import type { TagSortField, TagSortDirection } from "./tagUtils";

export function useTagsSearchParams() {
  const search = useSearch({
    from: "/admin",
  }) as AdminSearchParams;
  const navigate = useNavigate({ from: "/admin" });

  const sorting = useMemo(() => {
    const sortColumn = search.tagsSortBy as TagSortField | undefined;
    const sortDirection = (search.tagsSortDirection ?? "asc") as TagSortDirection;
    return {
      sortField: sortColumn ?? ("name" as TagSortField),
      sortDirection,
    };
  }, [search.tagsSortBy, search.tagsSortDirection]);

  const updateSearchParams = useCallback(
    (updates: { sortField?: TagSortField; sortDirection?: TagSortDirection }) => {
      const newSearch: AdminSearchParams = { ...search };

      if (updates.sortField === undefined) {
        delete newSearch.tagsSortBy;
        delete newSearch.tagsSortDirection;
      } else {
        newSearch.tagsSortBy = updates.sortField;
        newSearch.tagsSortDirection = (updates.sortDirection ?? "asc") as "asc" | "desc";
      }

      navigate({
        search: newSearch,
        replace: true,
      });
    },
    [search, navigate]
  );

  return {
    sorting,
    updateSearchParams,
  };
}
